/*
 *
 * Encoded HTML Decoder Service
 * Angular module: "trackerbase-app.services.encoded-html-decoder-service"
 * Exposed Service: EncodedHtmlDecoder
 *
 */

const mServiceName = new WeakMap();

class EncodedHtmlDecoderService {
    constructor() {
        mServiceName.set(this, "EncodedHtmlDecoder");
    }

    toString() {
        return mServiceName.get(this);
    }

    decode(encodedHtml) {
        if (encodedHtml != null) {
            // Previous implementation had an XSS problem.
            // See http://stackoverflow.com/questions/1912501/unescape-html-entities-in-javascript/34064434#34064434

            let domParser = new DOMParser();
            let tempDoc = domParser.parseFromString(encodedHtml, "text/html");
            let decodedHtml = tempDoc.documentElement.textContent;

            return decodedHtml;
        }
    }
}

EncodedHtmlDecoderService.$inject = [];

//While we don't need to use the angular injector for this service, we want angular's DI to manage the service's lifetime
export default angular
    .module("trackerbase-app.services.encoded-html-decoder-service",[
    ])
    .service("EncodedHtmlDecoder", EncodedHtmlDecoderService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/EncodedHtmlDecoderService.js
// module id = h/Rf
// module chunks = 1